var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 0.111084C4.98702 0.111084 0.111328 4.98678 0.111328 11C0.111328 17.0132 4.98702 21.8889 11.0002 21.8889C17.0134 21.8889 21.8891 17.0132 21.8891 11C21.8891 4.98678 17.0134 0.111084 11.0002 0.111084ZM11.778 16.25C11.778 16.3569 11.6905 16.4444 11.5836 16.4444H10.4169C10.3099 16.4444 10.2224 16.3569 10.2224 16.25V9.63886C10.2224 9.53192 10.3099 9.44442 10.4169 9.44442H11.5836C11.6905 9.44442 11.778 9.53192 11.778 9.63886V16.25ZM11.0002 7.88886C10.6949 7.88263 10.4042 7.75698 10.1905 7.53886C9.97682 7.32075 9.85712 7.02755 9.85712 6.7222C9.85712 6.41684 9.97682 6.12364 10.1905 5.90553C10.4042 5.68742 10.6949 5.56176 11.0002 5.55553C11.3055 5.56176 11.5962 5.68742 11.8099 5.90553C12.0236 6.12364 12.1433 6.41684 12.1433 6.7222C12.1433 7.02755 12.0236 7.32075 11.8099 7.53886C11.5962 7.75698 11.3055 7.88263 11.0002 7.88886Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.9875d5e64c735733320b4864b8ef61a4.svg";
export { ForwardRef as ReactComponent };